export default "__VITE_ASSET__Dx9X9w9s__"